import { useContext } from 'react';
import {
  DataAccessContext,
  useIsManager,
} from '@axo/shared/data-access/provider';
import { ace_index_hooks } from '@axo/shared/data-access/hooks';
import { permissions } from '@axo/shared/data-access/types';

export function useRelevantWorkingLists(marketCountry: string) {
  const isManager = useIsManager();

  const user = useContext(DataAccessContext).state.user;
  const roles = user.roles.map((role) => role.Name as permissions.RoleName);
  const clientID = user.clientID;

  const filter = isManager
    ? undefined
    : {
        MarketCountries: [marketCountry],
        Roles: roles,
        ClientIDs: [clientID],
      };

  return ace_index_hooks.useWorkingLists(filter);
}
